@if (subscribedSuccess) {
  @if (needsVerification && !verificationSuccess) {
    <ax-agreement-verification
      class="verification"
      [proposal]="proposal"
      [agreement]="agreement"
      [language]="language"
      [isExternal]="external"
      [autoVerification]="autoVerification"
      (verified)="verificationCompleted($event)"
      (verificationError)="verificationError.emit($event)"
      (resendSuccess)="resendSuccess.emit($event)"
    ></ax-agreement-verification>
  } @else {
    @if (payed === true && hasProducts) {
      <div>
        <ax-action-finished
          (didClickButton)="closeModal()"
          bodyTitle="payment.complete"
          [showButton]="false"
        ></ax-action-finished>
        <div class="view-agreement">
          <button axButton filled color="primary" (click)="success()">
            {{ 'agreement.view' | translate }}
          </button>
        </div>
      </div>
    }

    @if (!!successMessage && !hasProducts) {
      <div>
        <ax-action-finished
          (didClickButton)="closeModal()"
          [bodyTitle]="successMessage"
          [showButton]="false"
        ></ax-action-finished>
        <div class="view-agreement">
          <button axButton filled color="primary" (click)="success()">
            {{ 'agreement.view' | translate }}
          </button>
        </div>
      </div>
    }
  }
}
